import { ArrowDown, ArrowUp, History, Pencil, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

import { useMoveItem } from "../api";
import type { CatalogueItem, CatalogueKind } from "../types";

/** A row's move / edit / delete / history controls, the same on every tab. */
export function RowActions({
  kind,
  item,
  movable,
  isFirst,
  isLast,
  onEdit,
  onDelete,
  onHistory,
}: {
  kind: CatalogueKind;
  item: CatalogueItem;
  movable: boolean;
  isFirst: boolean;
  isLast: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onHistory: () => void;
}) {
  const { t } = useTranslation();
  const move = useMoveItem(kind);
  return (
    <div className="flex flex-wrap items-center gap-1">
      {movable && (
        <>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            aria-label={t("catalogue.moveUp")}
            title={t("catalogue.moveUp")}
            disabled={isFirst || move.isPending}
            onClick={() => move.mutate({ id: item.id, direction: "up" })}
          >
            <ArrowUp aria-hidden />
          </Button>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            aria-label={t("catalogue.moveDown")}
            title={t("catalogue.moveDown")}
            disabled={isLast || move.isPending}
            onClick={() => move.mutate({ id: item.id, direction: "down" })}
          >
            <ArrowDown aria-hidden />
          </Button>
        </>
      )}
      <Button type="button" variant="ghost" size="sm" onClick={onEdit}>
        <Pencil aria-hidden />
        {t("catalogue.edit")}
      </Button>
      <Button type="button" variant="ghost" size="sm" onClick={onDelete}>
        <Trash2 aria-hidden />
        {t("catalogue.delete")}
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onHistory}
        title={t("catalogue.historyTitle")}
      >
        <History aria-hidden />
        {t("catalogue.history")}
      </Button>
    </div>
  );
}
